import { NbMenuItem } from '@nebular/theme';
import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { NbAccessChecker } from '@nebular/security';

@Injectable()
export class PagesMenu {

    constructor(
        public accessChecker: NbAccessChecker
    ) { }

    private menusDisponiveis = [
        {
            index: 1,
            icon: 'fa fa-home',
            title: 'Principal',
            link: '/pages/acompanhamento-pedidos',
            tab: true,
        },
        {
            index: 2,
            icon: 'fa fa-chart-line',
            title: 'Dashboard',
            link: '/pages/dashboard',
            tab: true,
        },
        {
            index: 4,
            icon: 'fa fa-address-card',
            title: 'Clientes',
            link: '/pages/solicitacoes-cadastros-clientes',
            tab: true,
        },
        {
            index: 5,
            icon: 'fa fa-file-alt',
            title: 'Pedidos',
            link: '/pages/pedidos',
            tab: true,
        },
        {
            index: 6,
            title: "Usuários",
            icon: 'fa fa-users',
            link: '/pages/administracao/usuario',
            tab: true,
        },
        {
            index: 7,
            title: "Avisos",
            icon: 'fa fa-bell',
            link: '/pages/administracao/avisos',
            tab: true,
        },
        {
            index: 8,
            title: "Aprovadores de Pedido",
            icon: 'fa fa-user-check',
            link: '/pages/administracao/aprovador-pedido',
            tab: true,
        },
    ];

    getMenu(): Observable<NbMenuItem[]> {

        let menusAutorizados = [];

        this.menusDisponiveis.forEach(menu => {

            this.accessChecker.isGranted('view', menu.link).subscribe(permitido => {

                if (permitido)
                    menusAutorizados.push(menu);
            });
        });

        let menusAutorizadosOrdenados = menusAutorizados.sort((a, b) => {
            if (a.index < b.index) return -1;
            else if (a.index > b.index) return 1;
            else return 0;
        });

        return observableOf(menusAutorizadosOrdenados);
    }
}
